import React, { useState } from "react";

const NodesAddedRow = (props) => {
  const [ModalIsOpen, setModalIsOpen] = useState(false);

  const handleDelete = () => {
    props.ShowDeleteAddedItem(props.Item, props.i + props.Items.length);
    setModalIsOpen(false);
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <div className="form-row">
      <div className="xlarge select-holder">
        <select
          id={"select-parent-" + props.Index + "-filter"}
          onChange={() => props.HandleParentChange(props.Index)}
        >
          <option selected disabled>
            {translateText("not_specified")}
          </option>
          {props.Parents.map((Scope) => (
            <React.Fragment>
              <option key={Scope.Id} value={Scope.Id}>
                {Scope.Name}
              </option>
            </React.Fragment>
          ))}
        </select>
        <i className="feather-chevron-down cx-select-icon"></i>
        <p className="validation-error" id={"validation-parent-" + props.Index}>
          {translateText("specify_parent_error") + "."}
        </p>
      </div>
      <div className="xlarge select-holder">
        <select
          id={"select-child-" + props.Index + "-filter"}
          onChange={() => props.HandleChildChange(props.Index)}
        >
          <option selected disabled>
            {translateText("not_specified")}
          </option>
        </select>
        <i className="feather-chevron-down cx-select-icon"></i>
        <p className="validation-error" id={"validation-child-" + props.Index}>
          {translateText("specify_child_error") + "."}
        </p>
      </div>
      <div className="xlarge select-holder">
        <select
          id={"select-permissions-" + props.Index + "-filter"}
          onChange={() => props.HandlePermissionChange(props.Index)}
        >
          <option selected disabled>
            {translateText("not_specified")}
          </option>
          <option value="Hide">Hide</option>
          <option value="UnHide">Unhide</option>
        </select>
        <i className="feather-chevron-down cx-select-icon"></i>
        <p
          className="validation-error"
          id={"validation-permission-" + props.Index}
        >
          {translateText("specify_permission_error") + "."}
        </p>
      </div>
      <section className="large left-last">
        <button
          onClick={() =>
            props.DuplicateItem(props.Item, props.i + props.Items.length)
          }
        >
          <i className="feather-copy"></i>
        </button>
        <button
          className="added-item-context-menu"
          onClick={() => setModalIsOpen(!ModalIsOpen)}
        ></button>
      </section>
      <div className="more-info">
        <div
          style={{ display: "block" }}
          className={ModalIsOpen ? "modal-space" : "hidden"}
          id={"modal-" + parseInt(props.Items.length + props.i)}
        >
          <div className="modal-body double-item">
            <button className="btn" onClick={() => handleDelete()}>
              <img alt="" src={props.Delete} />
              <div className="btn-text">
                <p>{translateText("delete")}</p>
                <p>{translateText("delete_this_record")}</p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NodesAddedRow;
